import React from 'react';
import styles from './Table.module.css';

const Table = ({ columns, rows, emptyMessage = 'No data yet.' }) => {
    if (!rows || rows.length === 0) {
        return (
            <div className={styles.emptyState}>
                <h4 className={styles.emptyTitle}>Nothing to show yet</h4>
                <p className={styles.emptyText}>{emptyMessage}</p>
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col.key} className={styles.th}>
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr key={row.id || rowIndex} className={styles.tr}>
                            {columns.map((col) => (
                                <td key={col.key} className={styles.td}>
                                    {col.render ? col.render(row) : row[col.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table;

